var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedInj0)",
    d: "M6.806 7.513c.086-.108.171-.21.266-.313l.017-.013l.03-.026l.008-.008A3.1 3.1 0 0 1 8.19 6.51a2.76 2.76 0 0 1 2.859.66c1.17 1.093 1.067 2.858.128 4.028c-1.174 1.749-3.201 4.188-.394 6.373c.501.39.879.716 2.464 1.174c-1.037.193-2.001.129-3.073-.141c-.758-.428-1.95-1.346-2.357-2.584c-.613-1.877 1.08-4.68 1.899-5.76c1.123-1.5-.694-3.116-2.032-1.307c-.698.942-1.924 3.604-1.5 5.584c.253 1.118.583 1.937 1.895 3.06a6.5 6.5 0 0 1-.707-.489a6.93 6.93 0 0 1-.566-9.595"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedInj1)",
    d: "M17.194 16.487q-.126.16-.265.313l-.017.013l-.03.025l-.009.009a3.1 3.1 0 0 1-1.063.643c-.956.343-2.023.128-2.858-.66c-1.17-1.093-1.063-2.859-.129-4.029c1.174-1.748 3.201-4.187.394-6.373c-.501-.39-.878-.715-2.464-1.174a6.9 6.9 0 0 1 3.073.141c.758.43 1.95 1.346 2.357 2.585c.613 1.877-1.08 4.68-1.899 5.76c-1.122 1.5.695 3.115 2.032 1.307c.698-.943 1.924-3.604 1.5-5.584c-.253-1.119-.583-1.938-1.894-3.06q.366.218.707.488a6.93 6.93 0 0 1 .565 9.596"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedInj0",
    x1: 5.143,
    x2: 28.351,
    y1: 11.334,
    y2: 11.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedInj1",
    x1: 5.143,
    x2: 18.857,
    y1: 12,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F2FE"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInj);
export default __webpack_public_path__ + "static/media/inj.47c2d8b0fc8f8f354c25af76a3193f3d.svg";
export { ForwardRef as ReactComponent };